const linemapdata = [
  {
    id: "japan",
    color: "hsl(218, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 203,
      },
      {
        x: "helicopter",
        y: 153,
      },
      {
        x: "boat",
        y: 47,
      },
      {
        x: "train",
        y: 78,
      },
      {
        x: "subway",
        y: 200,
      },
      {
        x: "bus",
        y: 70,
      },
      {
        x: "car",
        y: 280,
      },
      {
        x: "moto",
        y: 188,
      },
      {
        x: "bicycle",
        y: 61,
      },
      {
        x: "horse",
        y: 184,
      },
      {
        x: "skateboard",
        y: 8,
      },
      {
        x: "others",
        y: 20,
      },
    ],
  },
  {
    id: "france",
    color: "hsl(102, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 229,
      },
      {
        x: "helicopter",
        y: 276,
      },
      {
        x: "boat",
        y: 218,
      },
      {
        x: "train",
        y: 295,
      },
      {
        x: "subway",
        y: 263,
      },
      {
        x: "bus",
        y: 280,
      },
      {
        x: "car",
        y: 226,
      },
      {
        x: "moto",
        y: 200,
      },
      {
        x: "bicycle",
        y: 147,
      },
      {
        x: "horse",
        y: 178,
      },
      {
        x: "skateboard",
        y: 132,
      },
      {
        x: "others",
        y: 85,
      },
    ],
  },
  {
    id: "us",
    color: "hsl(163, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 225,
      },
      {
        x: "helicopter",
        y: 92,
      },
      {
        x: "boat",
        y: 105,
      },
      {
        x: "train",
        y: 281,
      },
      {
        x: "subway",
        y: 17,
      },
      {
        x: "bus",
        y: 203,
      },
      {
        x: "car",
        y: 62,
      },
      {
        x: "moto",
        y: 63,
      },
      {
        x: "bicycle",
        y: 166,
      },
      {
        x: "horse",
        y: 87,
      },
      {
        x: "skateboard",
        y: 41,
      },
      {
        x: "others",
        y: 205,
      },
    ],
  },
  {
    id: "germany",
    color: "hsl(294, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 12,
      },
      {
        x: "helicopter",
        y: 148,
      },
      {
        x: "boat",
        y: 212,
      },
      {
        x: "train",
        y: 200,
      },
      {
        x: "subway",
        y: 191,
      },
      {
        x: "bus",
        y: 44,
      },
      {
        x: "car",
        y: 287,
      },
      {
        x: "moto",
        y: 78,
      },
      {
        x: "bicycle",
        y: 257,
      },
      {
        x: "horse",
        y: 245,
      },
      {
        x: "skateboard",
        y: 207,
      },
      {
        x: "others",
        y: 175,
      },
    ],
  },
  {
    id: "norway",
    color: "hsl(322, 70%, 50%)",
    data: [
      {
        x: "plane",
        y: 147,
      },
      {
        x: "helicopter",
        y: 237,
      },
      {
        x: "boat",
        y: 145,
      },
      {
        x: "train",
        y: 150,
      },
      {
        x: "subway",
        y: 285,
      },
      {
        x: "bus",
        y: 111,
      },
      {
        x: "car",
        y: 44,
      },
      {
        x: "moto",
        y: 137,
      },
      {
        x: "bicycle",
        y: 224,
      },
      {
        x: "horse",
        y: 286,
      },
      {
        x: "skateboard",
        y: 38,
      },
      {
        x: "others",
        y: 216,
      },
    ],
  },
];
export default linemapdata;